import { ReactNode } from "react";
import { isEmpty } from "lodash";
import { ErrorBoundaryDefault } from "@src/app/components/ErrorBoundary/ErrorBoundaryDefault.component";

interface MainProps {
  banners?: ReactNode;
  breadcrumbs?: ReactNode;
  children: ReactNode;
  title?: string;
}

export default function Main(props: MainProps) {
  const { banners, breadcrumbs, children, title } = props;

  return (
    <div className="app_main sg-flex sg-flex-col sg-gap-9 sg-mt-4 sg-mb-6">
      {!isEmpty(title) && <h1 className="sg-mt-5">{title}</h1>}

      {banners && <section>{banners}</section>}

      {breadcrumbs && <section className="sg-mb-5">{breadcrumbs}</section>}

      <ErrorBoundaryDefault>
        <section>{children}</section>
      </ErrorBoundaryDefault>
    </div>
  );
}
